import { detalheRedeCredenciada } from '@/views/4/RegrasDeNegocio4'

const lineBreak = `\n`

const urlMapa = (latitude, longitude) => {
  const lat = latitude.replace(',', '.')
  const lng = longitude.replace(',', '.')
  return `https://google.com/maps/?q=${lat},${lng}`
}

function getLinkMapa (prestador, TextoRedeCredenciada) {
  if (prestador.latitude && prestador.longitude) {
    return `Mapa: ${urlMapa(prestador.latitude, prestador.longitude)} ${lineBreak}`
  }
  return ''
}

function getTextoRedeCredenciada (prestador) {
  let endereco = `${prestador.endereco}`

  if (prestador.numero) {
    endereco += ` ${prestador.numero}`
  }

  if (prestador.complemento) {
    endereco += ` ${prestador.complemento}`
  }

  if (prestador.bairro) {
    endereco += ` ${prestador.bairro}`
  }

  if (prestador.nome_cidade) {
    endereco += ` ${prestador.nome_cidade}`
  }

  if (prestador.nome_estado) {
    endereco += ` ${prestador.nome_estado}`
  }

  if (prestador.cep) {
    endereco += ` ${prestador.cep}`
  }

  let TextoRedeCredenciada = `Prestador: ${prestador.nome_prestador}${lineBreak}`

  if (prestador.especialidade) {
    TextoRedeCredenciada += `Especialidade: ${prestador.especialidade}${lineBreak}`
  }
  if (prestador.telefone_primario) {
    TextoRedeCredenciada += `Contato: ${prestador.telefone_primario}${lineBreak}`
  }
  if (endereco) {
    TextoRedeCredenciada += `Endereço: ${endereco}${lineBreak}`
  }

  return TextoRedeCredenciada
}

const preloadWidget = async (idOperadora, idPrestador, espagr, funcionalidade, authorization) => {
  const prestador = await detalheRedeCredenciada(idOperadora,
    idPrestador,
    espagr)

  const textoRedeCredenciada = `${getTextoRedeCredenciada(prestador)}${getLinkMapa(prestador)}`
  const textoRedeCredenciadaChat = getTextoRedeCredenciada(prestador)

  const payload = {
    'idOperadora': idOperadora,
    'idPrestador': idPrestador,
    'espagr': espagr,
    'textoRedeCredenciada': textoRedeCredenciada,
    'textoRedeCredenciadaChat': textoRedeCredenciadaChat
  }
  return createPayload(payload, funcionalidade, authorization)
}

function createPayload (detalhe, funcionalidade, authorization) {
  const payload = {
    'idFuncionalidade': funcionalidade.idFuncionalidade,
    'data': {},
    'configuracao': {
      'parametros': {},
      'metodoEnvio': []
    },
    'opcoesDeEnvio': []
  }
  const { configuracoesDeWidgets } = funcionalidade.parametros

  if (configuracoesDeWidgets.permiteEnvioChatWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 1,
        'descricao': 'Mensagem no chat'
      },
      'sincrono': true
    })
  }
  if (configuracoesDeWidgets.permiteEnvioEmailWidget && configuracoesDeWidgets.templateEnvioEmailWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 2,
        'descricao': 'E-mail'
      },
      'template': configuracoesDeWidgets.templateEnvioEmailWidget,
      'sincrono': true
    })
  }
  if (configuracoesDeWidgets.permiteEnvioWhatsappWidget && configuracoesDeWidgets.templateEnvioWhatsappWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 3,
        'descricao': 'WhatsApp'
      },
      'template': configuracoesDeWidgets.templateEnvioWhatsappWidget,
      'sincrono': true
    })
  }
  payload.opcoesDeEnvio.push({
    'nome': 'Detalhes do prestador',
    'nomeIntegracao': 'detalhePrestador',
    'integracao': {
      'headers': {
        'Authorization': authorization
      },
      'parametros': {},
      'rota': {
        ...funcionalidade.rotas.detalhePrestador
      },
      'payload': {
        'idOperadora': detalhe.idOperadora,
        'idPrestador': detalhe.idPrestador,
        'espagr': detalhe.espagr ? 'S' : 'N'
      }
    },
    'data': {
      'tituloWidget': `Detalhes do prestador`,
      'textoRedeCredenciada': detalhe.textoRedeCredenciada,
      'textoRedeCredenciadaChat': detalhe.textoRedeCredenciadaChat
    }
  })
  return payload
}
export { preloadWidget }
